import { render, staticRenderFns } from "./VoicemailBackupLog.vue?vue&type=template&id=6e56ebf0&scoped=true"
import script from "./VoicemailBackupLog.vue?vue&type=script&lang=js"
export * from "./VoicemailBackupLog.vue?vue&type=script&lang=js"
import style0 from "./VoicemailBackupLog.vue?vue&type=style&index=0&id=6e56ebf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56ebf0",
  null
  
)

export default component.exports